export const ACTION_CODE = 'TRAINING_STUDENT_TYPES' + '_ACTION';
